module.exports = __webpack_public_path__ + "img/SkuQueryS1Page.0df5921b.png";